import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {};

const campaignRegionNominationsReducerMap = {
	[types.UPDATE_FILTER]: (state, action) => {
		return { filter: action.payload.filter };
	},
	[types.RESET_FILTER]: () => {
		return {};
	},
};

export default handleActions(campaignRegionNominationsReducerMap, initialState);
